// openBaseInvite.js — cross-component event to open Invite Members

const OPEN_BASE_INVITE_EVENT = 'orbital:open-base-invite';

/**
 * Requests that the invite members modal open for the active base.
 * Fire-and-forget; the switcher toggle listens and opens the modal.
 */
export function openBaseInvite() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(OPEN_BASE_INVITE_EVENT));
  }
}

/**
 * Subscribes to open-invite requests.
 *
 * @param {Function} handler
 * @returns {Function} unsubscribe
 */
export function subscribeOpenBaseInvite(handler) {
  if (typeof window === 'undefined' || typeof handler !== 'function') {
    return () => {};
  }

  window.addEventListener(OPEN_BASE_INVITE_EVENT, handler);
  return () => {
    window.removeEventListener(OPEN_BASE_INVITE_EVENT, handler);
  };
}
